import { Icon } from "./Icon";
export const IconStarHalf = (props) => (
  <Icon {...props}>
    <path d="M5.71,9,2.18,10.86l.67-3.93L0,4.15l3.94-.58L5.71,0Z"/>
  </Icon>
);
